import * as Yup from "yup";
import {yupResolver} from "@hookform/resolvers/yup";

export const companySchema = Yup.object().shape({
	name: Yup.string().required('Name/Alias is a required field.').min(2, 'Must be at least 2 characters.')
}).required();

export const companyResolver = { resolver: yupResolver(companySchema)}